module.exports = __webpack_public_path__ + "img/Arrival__Loading__Icon--has-token@2x.a1fe467c.png";